module.exports = __webpack_public_path__ + "static/media/warningSound.137d1d6c.mp3";